<template>
  <v-layout row wrap>
    <v-flex md6 xs12 px-2>
      <v-text-field
        v-model="title"
        :label="label"
        disabled
        prepend-icon="attach_file"
      />
      <clipper-upload ref="upload" :value="image" @input="fileChanged">
        <v-btn class="primary" small>
          {{ buttonTitle }}
        </v-btn>
      </clipper-upload>
    </v-flex>
    <v-flex v-if="image" md3 sm6 xs12 px-2>
      <div style="max-width: 150px">
        <clipper-preview class="basic md" name="preview" />
      </div>
    </v-flex>
    <v-flex v-if="image" md3 sm6 xs12 px-2>
      <div style="max-width: 150px">
        <clipper-fixed :src="image" class="basic lg" preview="preview" />
      </div>
    </v-flex>
  </v-layout>
</template>

<script>
import { clipperFixed, clipperPreview, clipperUpload } from 'vuejs-clipper'
export default {
  name: 'ButtonUpload',
  components: {
    clipperFixed,
    clipperPreview,
    clipperUpload,
  },
  props: {
    image: {
      type: String,
      required: false,
      default: '',
    },
    title: {
      type: String,
      required: false,
      default: '',
    },
    label: {
      type: String,
      required: false,
      default: '',
    },
  },
  data() {
    return {}
  },
  computed: {
    buttonTitle() {
      return this.image
        ? this.$t('action.actions.change', {
            field: this.$t('fields.users.image'),
          })
        : this.$t('action.actions.upload', {
            field: this.$t('fields.users.image'),
          })
    },
  },
  methods: {
    fileChanged(image) {
      this.$emit('update:image', image)
      this.$emit('file', this.$refs.upload.file)
      this.$emit('update:title', this.$refs.upload.file.name)
    },
  },
}
</script>
